import { GET_TASK, GET_TASK_SUCCESS, GET_TASK_ERROR} from './actionTypes';

const initialState = {
    errorGetTask: "",
    loadingGetTask: false,
    tasks: null,
    successTask: ""
}

const getTask = (state = initialState, action) => {
    switch (action.type) {
        case GET_TASK:
            state = {
                ...state,
                loadingGetTask: true
            }
            break;
        case GET_TASK_SUCCESS:
            state = {
                ...state,
                loadingGetTask: false,
                tasks: action.payload.tasks, 
                successTask: action.payload.message
            }
            break;
        case GET_TASK_ERROR:
            state = { ...state, errorGetTask: action.payload, loadingGetTask: false };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default getTask;